/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ReturnUrlProducts {
    Vb = 'vb',
}
